import React, { useState } from "react";
import { useAlert } from "react-alert";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../common/CustomModal.css";
import { variables } from "../../Variables.json";
import api from "../../seller-apis/api";
import axios from "axios";
import { GenUtilities } from "../../utilities/GenUtilities";

const VideoModalUpload = ({ show, handleClose, handleConfirm, product }) => {
    const [video,setVideo]=useState("");
    const [progress, setProgress] = useState();
    const alert=useAlert();
    var videosName=[];
    function addVideo(event) {
        console.log("addVideo");
        // setvidurlListshow(false);
        let comImg;
        let imageFinal;
        let registerImage;
        let videoSize = 0;
        let vendorId = product?.vendor?._id;
        if (event.target.files.length > 1) {
          alert.info("A max of 1 video can be uploaded");
          return false;
        //   setvidurlListshow(true);
        }
        if (event.target.files.length > 0) {
          for (let i = 0; i < 1; i++) {
            videoSize = videoSize + event.target.files[i].size;
          }
          if (videoSize <= variables.limit.Newproductupload.video) {
            for (let i = 0; i < 1; i++) {
              var str = event.target.files[i].name;
              let extension = event.target.files[i].name.slice(
                event.target.files[i].name.lastIndexOf(".")
              );
              comImg = str.replace(/[^\w]/g, "");
              imageFinal = "vid_" + vendorId + "_" + comImg + extension;
              registerImage = event.target.files[0];
              var data = {
                imageName: imageFinal,
                type: "products",
                bucket: "m",
              };
              imageFinal = GenUtilities.removeSpacesFromName("vid_" + vendorId + "_" + comImg + extension);
              videosName.push(imageFinal);
              api.product
                .saveProductImage(data)
                .then((res) => {
                  axios({
                    method: "put",
                    url: res.data,
                    data: registerImage,
                    onUploadProgress: (data) => {
                      setProgress(Math.round((100 * data.loaded) / data.total));
                    },
                  })
                    .then((response) => {
                      setProgress();
                      setVideo(videosName);
                    //   setvidurlList(videosName);
                    //   setvidurlListshow(true);
                    })
                    .then((response) => {
                      setProgress();
                      setVideo(videosName);
                    //   setvidurlList(videosName);
                    //   setvidurlListshow(true);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                })
                .catch((err) => console.log(err));
            //   vids3Urls.push(imageFinal);
            }
          } else {
            alert.info("A max size of 15 Mb video can be uploaded");
          }
        }
      }
      const addProduct = () => {
        product['videos'] = Array.isArray(video) ?video:[video];
        api.product
          .addNewProduct(product)
          .then((res) => {
            alert.success("Video added successfully");
            handleClose();
            // if (NewVendTotalprcount === 0) {
            //   NewVendTotalprcount = NewVendTotalprcount + 1;
            //   pkgData.product = res._id;
            //   window.location.assign("/regprosuccess");
            // } else {
            //   window.location.assign("/my-inventory/new_product_request/manual");
            // }
          })
          .catch((err) => {
            console.log(err);
            alert.error("Failed to add video");
          });
      };
  return (
    <Modal className="custom-modal" centered show={show} onHide={handleClose}>
      <Modal.Body>
        <div className="no-data draft-upload-video">
          {/* No Media Available, Please add Product Image & Video
                        from Edit Product Option */}
          <label
            className="upload-file img-upload file-upload"
            htmlFor={`file-upload-input`}
          >
            <img src="/upload.webp" alt="upload" />
            Upload Video
            <input
              id={`file-upload-input`}
              onChange={(e) => {
                addVideo(e);
              }}
              type="file"
              accept="video/*"
            />
          </label>
          or
          <input type="text" name="video" placeholder="Add video url" className="add_pro_form_card_input" onChange={(e) => {setVideo(e.target.value)}} />
        </div>

        <div className="action-buttons">
          
            
          <Button
            className="yes-button"
            variant="secondary flex-center"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button variant="primary" onClick={()=>addProduct()} className="no-button flex-center">
              Add Video
            </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModalUpload;
